const getDaysUntilDate = dateValue => {
    if (!dateValue || typeof dateValue !== 'string') return null;
    const [day, month, year] = dateValue.split('-').map(Number);
    if (!day || !month || !year) return null;

    const selectedDate = new Date(year, month - 1, day);
    if (Number.isNaN(selectedDate.getTime())) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    // Use inclusive counting so today is day 1.
    return Math.floor((selectedDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)) + 1;
};

export const filterTravelCancellationPackages = ({ packages = [], travelStartDate }) => {
    if (!Array.isArray(packages) || packages.length === 0) return [];

    const daysUntilTravelStart = getDaysUntilDate(travelStartDate);
    const isWithin14Days =
        daysUntilTravelStart !== null &&
        daysUntilTravelStart >= 1 &&
        daysUntilTravelStart <= 14;
    if (!isWithin14Days) return packages;

    const preferredPackage =
        packages.find(pkg => pkg?.value === 'CDT') ||
        packages.find(pkg => pkg?.value === 'premium') ||
        packages.find(pkg => `${pkg?.title || ''}`.toLowerCase().includes('during')) ||
        packages[0];

    return preferredPackage ? [preferredPackage] : packages;
};